import React from 'react';
import { Flag } from 'semantic-ui-react';

const isValidIsoCode = (code: string) => typeof code === 'string' && /^[a-zA-Z]{2}$/.test(code.trim());

const LocationTableComponent = props => {
  return (
    <div className="locations-component__wrapper">
      {isValidIsoCode(props.isoCode) && <Flag name={props.isoCode.toLowerCase() as any} />}
      <span>
        {props.location} - {props.country}
      </span>
    </div>
  );
};

export default LocationTableComponent;
